import { get, post } from 'common/utils/request';
export var fetchNeedFeedbackApi = function (feedbackSectionType) {
    return get("/feedback/is-time-to-request-feedback?feedbackSectionType=".concat(feedbackSectionType));
};
export var createFeedbackApi = function (data) {
    return post('/feedback', data);
};
